export enum Sizes {
  fullScreen = 'FULL_SCREEN',
  large = 'LARGE',
  medium = 'MEDIUM',
  small = 'SMALL',
}
